import { useCallback, useEffect, useState } from "react";
import { config } from "../../tools/config/singleProcessData";
import LoadingSpinner from "../../components/Visuals";
import MarketSortableTable from "../../components/MarketSortableTable";
import {
    calculate_cross_value,
    calculate_legal_seller,
} from "../../tools/market/functions";

function MarketSinglePage() {
    const [stockList, setStockList] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [firstRecords, setFirstRecords] = useState(
        JSON.parse(localStorage.getItem("first_records")) || []
    );

    const url = new URL(window.location.href);
    // const today = new Date().getFullYear() + '/' + parseInt(new Date().getMonth() + 1) + '/' + new Date().getDate()

    const date = url.searchParams.get("date");
    const filterBy = url.searchParams.get("stockFilter");

    const fetchData = useCallback(async () => {
        const response = await fetch(
            `${process.env.REACT_APP_MARKET}/market/single/?date=${date}&stock=${filterBy}`
        );
        const symbolList = await response.json();

        setStockList(() => {
            return symbolList.map((row) => {
                return { ...row, power_buy: calculate_cross_value(row) };
            });
        });
        setLoading(false);
    }, [date, filterBy]);

    const fetchFirstRecordsData = useCallback(async () => {
        const response_ = await fetch(
            `${process.env.REACT_APP_MARKET}/market/first_records`
        );
        const data = await response_.json();
        localStorage.setItem("first_records", JSON.stringify(data));
        localStorage.setItem(
            "first_records_date",
            new Date().toJSON().slice(0, 10)
        );
        setFirstRecords(data);
    }, []);

    const checkFirstDay = (row) => {
        for (let i = 0; i < firstRecords.length; i++) {
            for (const [key, value] of Object.entries(firstRecords[i])) {
                if (
                    key === row["tse_url"] &&
                    date === value.replaceAll("-", "")
                ) {
                    return true;
                }
            }
        }
        return false;
    };    

    const handleFilter = () => {
        setLoading(true)
        if (!isFilter) {
            setIsFilter(true)

            let filteredData;
            filteredData = stockList.filter((row) => {
                return checkFirstDay(row) === false;
            });

            filteredData = filteredData.filter((row) => {
                return row.power_buy > -5;
            });

            filteredData = filteredData.filter((row) => {
                if (
                    !row["legal"] ||
                    parseInt(row['legal']) === 0 ||
                    (Number(row['legal']) === row['legal'] && row['legal'] % 1 !== 0 && isNaN(row["legal"]))
                ) {
                    return false;
                }
                if (
                    calculate_legal_seller(row) < 30000000 &&
                    row["legal"]["count sell ha"] > 3 * row["legal"]["count buy ha"]
                ) {
                    return false;
                }
                return true;
            });

            setStockList((prevStockList) => {
                return prevStockList.filter(item => !filteredData.includes(item));
            });
        } else {
            setIsFilter(false)
            fetchData()
        }
        setLoading(false)
    };

    useEffect(() => {
        setLoading(true);
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (
            firstRecords.length === 0 ||
            localStorage.getItem("first_records_date") !==
            new Date().toJSON().slice(0, 10)
        ) {
            fetchFirstRecordsData();
        }
    }, [fetchFirstRecordsData, firstRecords]);

    return (
        <div className="content flex-row-fluid" id="kt_content" dir="rtl">
            <div className="container-fluid mt-lg-0 mt-5">
                <div className="row">
                    <div className="col-xl-12 d-block">
                        <div className="h-100">
                            {date && filterBy ? (
                                isLoading ? (
                                    <LoadingSpinner />
                                ) : (
                                    <MarketSortableTable
                                        config={config}
                                        rows={stockList}
                                        onFilter={handleFilter}
                                        filterBy={filterBy}
                                        single={true}
                                        isFilter={isFilter}
                                        date={date}
                                        theme="table-striped"
                                    />
                                )
                            ) : (
                                <div className="alert alert-warning">
                                    موردی یافت نشد
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MarketSinglePage;
